const defaultState = {
  loading: true,
  language: {},
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
  case 'FETCH_LANGUAGE_STRINGS_PENDING': {
    return {
      ...state,
      loading: true,
    };
  }

  case 'FETCH_LANGUAGE_STRINGS_FULFILLED': {
    // Use this for updating moment when we add languages
    // const language = action.payload.data?.meta?.locale || 'en-GB';

    return {
      ...state,
      language: action.payload.data.data,
      loading: false,
    };
  }

  case 'FETCH_LANGUAGE_STRINGS_REJECTED': {
    // Disabled because we want to log errors
    // eslint-disable-next-line no-console
    console.log('Error loading language strings', action.payload.message);

    return {
      ...state,
      loading: false,
      language: false,
    };
  }

  default:
    return state;
  }
};
